export default {
	state: {
		deleteLoading: {
			loading: false,
		},
	},
	mutations: {
		requestDeleting(state) {
			state.deleteLoading.loading = true;
		},
		successDeleted(state) {
			state.deleteLoading.loading = false;
		},
	},
	actions: {
		async deleteTheClientDetail({ commit }, params) {
			commit('requestDeleting');
			await a.api('deleteKhd', params);
			commit('successDeleted');
		},
	},
};
